<template>
  <div class="step-timeline" :class="{ 'step-timeline--compact': compact }">
    <div
      v-for="(step, index) in steps"
      :key="step.step"
      class="step-node"
      :class="`step-node--${step.status.toLowerCase()}`"
    >
      <!-- 앞 스텝과 이어주는 선 -->
      <span v-if="index > 0" class="step-connector" aria-hidden="true"></span>

      <a-tooltip :title="tooltipOf(step)">
        <span class="step-marker">{{ markerOf(step.status) }}</span>
      </a-tooltip>

      <span v-if="!compact" class="step-label">
        {{ step.label }}
        <span v-if="step.isAlimtalk" class="step-badge">톡</span>
      </span>
    </div>
  </div>
</template>

<script>
import { STEP_STATUS_META } from "../seolbiTrackingApi";

// 상태별 마커 문자 — 한눈에 스캔되도록 색과 함께 씁니다.
const STATUS_MARKER = {
  DONE: "✓",
  IN_FLIGHT: "…",
  STALLED: "⏸",
  FAILED: "✕",
  MISSING: "!",
  PENDING: "",
};

export default {
  name: "SeolbiStepTimeline",
  props: {
    steps: {
      type: Array,
      required: true,
    },
    // 목록 셀에 들어갈 때는 라벨 없이 마커만 그립니다.
    compact: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const markerOf = (status) => STATUS_MARKER[status] ?? "";

    const tooltipOf = (step) => {
      const meta = STEP_STATUS_META[step.status];
      const parts = [`${step.label} · ${meta?.label ?? step.status}`];

      if (step.at) {
        parts.push(new Date(step.at).toLocaleString("ko-KR"));
      }

      // 원인 설명은 상태 메타에 한 곳으로 모아 뒀습니다.
      if (meta?.description && step.status !== "DONE") {
        parts.push(meta.description);
      }

      if (step.error) {
        parts.push(step.error);
      }

      return parts.join("\n");
    };

    return { markerOf, tooltipOf };
  },
};
</script>

<style scoped>
.step-timeline {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 0;
}

.step-node {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  min-width: 78px;
  padding: 0 4px;
}

.step-timeline--compact .step-node {
  min-width: 26px;
  padding: 0;
}

.step-connector {
  position: absolute;
  top: 11px;
  right: 50%;
  width: 100%;
  height: 2px;
  background: #f0f0f0;
  z-index: 0;
}

.step-timeline--compact .step-connector {
  top: 9px;
}

.step-marker {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  background: #fff;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  cursor: help;
}

.step-timeline--compact .step-marker {
  width: 18px;
  height: 18px;
  font-size: 11px;
}

.step-node--done .step-marker {
  background: #52c41a;
  border-color: #52c41a;
}

.step-node--in_flight .step-marker {
  background: #1890ff;
  border-color: #1890ff;
}

/* 컨슈머가 job을 가져가지 않은 상태 — 발송 실패와 색으로 구분 */
.step-node--stalled .step-marker {
  background: #eb2f96;
  border-color: #eb2f96;
}

.step-node--failed .step-marker {
  background: #f5222d;
  border-color: #f5222d;
}

.step-node--missing .step-marker {
  background: #fa8c16;
  border-color: #fa8c16;
}

.step-node--pending .step-marker {
  background: #fafafa;
  border-color: #d9d9d9;
}

.step-label {
  margin-top: 6px;
  font-size: 11px;
  line-height: 1.3;
  color: #595959;
  text-align: center;
  word-break: keep-all;
}

.step-node--pending .step-label {
  color: #bfbfbf;
}

.step-badge {
  display: inline-block;
  margin-left: 2px;
  padding: 0 3px;
  border-radius: 2px;
  background: #f0f5ff;
  color: #2f54eb;
  font-size: 10px;
  vertical-align: middle;
}
</style>
